import React, {useState, useEffect} from "react";
import {
  useHistoricalStocksQuery
} from '../../data/home-data';

import { Table } from "components/ui/table";
import { Link  } from "react-router-dom";
import {Links} from '../../routes/PathLink'
import { APP_URL, periodData } from "components/config/Common";



export default function StockAction() {
    //const [stockData, setStockData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [active, setActive] = useState(null);
    const [period, setPeriod] = useState(null);
    const [access_token,setAccess_token] = useState(localStorage.getItem('access_token'));
    const [isLogin, setIsLogin] = useState(false)
    

    const { data:stockData, isLoading, isFetching } = useHistoricalStocksQuery({
        period,
    });

    useEffect(() => {        
        setPeriod('today')
        setActive('today')
    }, []);

    useEffect(() => {
        if(access_token){
            setIsLogin(true)
        }
    }, [access_token])

    //console.log('7days data',weekData)
    //console.log('one year data',yearData)

    const getHistoricData = (period) => {
        //console.log('period', period)
        setPeriod(period)
        setActive(period)
        
    }

    const skeleton = Array.from({ length: 10 }, (_, i) => ({
    id: `sk-${i}`,
    _isSkeleton: true
    }));
    
    const columns = [
        {
            title: 'Stock',
            dataIndex: 'Stock',
            key: 'id',
            align: 'left',            
            width: 100,
            render: (text, record) => (
                <Link className="text-accent" to={`${process.env.REACT_APP_URL}${Links.COMPANY}/${record.symbol}`} title={record.name}>
                    <div className="text-wrap line-clamp-1">
                        {record.name}
                    </div>
                </Link>
            ),
        },
        {
            title: 'Start',
            dataIndex: 'Start',
            key: 'id',
            align: 'left',
            width: 10,
            render: (text, record) => (
                <div>{record.price_start}</div>
            ),
        },
        {
            title: 'End',
            dataIndex: 'End',
            key: 'id',
            align: 'left',
            width: 10,
            render: (text, record) => (
                <div>{record.price_end}</div>
            ),
        },
        {
            title: 'Change',
            dataIndex: 'change',
            key: 'id',
            align: 'left',
            width: 10,
            render: (text, record) => (                
                <>
                {stockData &&
                <div className={`${Number(record.percent_change).toFixed(2) >= 0 ? 'text-green-600' : 'text-red-600'}`}>{Number(record.percent_change).toFixed(2)}%</div>
                }
                </>
            ),
        },
    ]

    return (
        <section className="bg-white dark:bg-gray-900 shadow-md px-5 lg:px-8 py-10 mb-10">
            <div className="flex items-center justify-between">
                <h2 className="text-2xl text-gray-800">STOCK ACTION</h2>
            </div>
            <div class="inline-flex flex-wrap rounded-base shadow-xs -space-x-px my-5" role="group">
                {periodData.map((val, key) => (

                <button key={`btn-${key}`} onClick={() => getHistoricData(`${val.id}`)} type="button" class={`${active == val.id ? 'bg-accent text-white' : 'bg-neutral-primary-soft'} text-body  border border-accent hover:bg-accent hover:text-white leading-5 rounded-s-base text-xs lg:text-sm px-2 py-1 focus:outline-none`}>
                    {val.label}
                </button>
                ))
                }
            </div>


            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                <div>
                
                <div>
                    <div className="flex items-center justify-between">
                    <div className="text-heading pb-2">Most Active <span className="text-xs text-gray-400">{stockData?.metadata?.start_date} - {stockData?.metadata?.end_date}</span></div>
                    
                    
                    {/*<Link className="text-xs text-accent" to={isLogin
                        ? `${APP_URL}/most-active-stocks/${active}`
                        : `${APP_URL}/login`}>View all</Link>*/}

                    <Link className="text-xs text-accent" to={`${APP_URL}/most-active-stocks/${active}`}>View all</Link>
                    </div>
                    <Table            
                    columns={columns}
                    rowKey="id"
                    data={isLoading ? skeleton : stockData?.most_active}
                    className="border border-gray-300 hover:shadow-lg rounded-md overflow-hidden hover:border-accent transition duration-500"
                    rowClassName={(record, index) => {
                        if (record._isSkeleton) {
                            // Animate only alternate skeleton rows (even rows)
                            return index % 2 === 0
                            ? "skeleton-row pulse-row"
                            : "skeleton-row-odd";
                        }
                        return "";
                    }}
                />
                    
                </div>
                
                </div>
                <div>
                
                <div>
                    <div className="flex items-center justify-between">
                        <div className="text-heading pb-2">Top Gainers <span className="text-xs text-gray-400">{stockData?.metadata?.start_date} - {stockData?.metadata?.end_date}</span>
                        </div>
                        {/*<Link className="text-xs text-accent" 
                        to={isLogin ? `${APP_URL}/top-gainers/${active}`: `${APP_URL}/login`}>View all</Link>*/}
                        <Link className="text-xs text-accent" 
                        to={`${APP_URL}/top-gainers/${active}`}>View all</Link>
                    </div>
                    <Table            
                    columns={columns}
                    rowKey="id"
                    data={isLoading ? skeleton : stockData?.top_gainers}
                    className="border border-gray-300 hover:shadow-lg rounded-md overflow-hidden hover:border-accent transition duration-500"
                    rowClassName={(record, index) => {
                        if (record._isSkeleton) {
                            // Animate only alternate skeleton rows (even rows)
                            return index % 2 === 0
                            ? "skeleton-row pulse-row"
                            : "skeleton-row-odd";
                        }
                        return "";
                    }}
                />                    
                </div>
                
                </div>
                <div>
                
                <div>
                    <div className="flex items-center justify-between">
                    <div className="text-heading pb-2">Top Losers <span className="text-xs text-gray-400">{stockData?.metadata?.start_date} - {stockData?.metadata?.end_date}</span></div>
                    {/*<Link className="text-xs text-accent" 
                        to={isLogin ? `${APP_URL}/top-losers/${active}` : `${APP_URL}/login`}
                    >View all</Link>*/}
                    <Link className="text-xs text-accent" 
                        to={`${APP_URL}/top-losers/${active}`}
                    >View all</Link>
                    </div>
                    <Table            
                    columns={columns}
                    rowKey="id"
                    data={isLoading ? skeleton : stockData?.top_losers}
                    className="border border-gray-300 hover:shadow-lg rounded-md overflow-hidden hover:border-accent transition duration-500"
                    rowClassName={(record, index) => {
                        if (record._isSkeleton) {
                            // Animate only alternate skeleton rows (even rows)
                            return index % 2 === 0
                            ? "skeleton-row pulse-row"
                            : "skeleton-row-odd";
                        }
                        return "";
                    }}
                />                    
                </div>
                
                </div>
            </div>
        </section>
        
    )
}